var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 13.38 14.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{clip-path:url(#clip-path-2);}.cls-4{fill:#1c3152;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 13.38,
    height: 14.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,7.45A2.78,2.78,0,1,1,7,9.87a2,2,0,0,1-.34,0A2.77,2.77,0,0,1,4,7.45M5.53.05a.38.38,0,0,0-.38.38L4.92,2A5.4,5.4,0,0,0,3.21,3L1.77,2.35a.39.39,0,0,0-.52.12L.07,4.42a.38.38,0,0,0,.13.52l1.24,1a5.12,5.12,0,0,0-.1,1.84c0,.22.07.43.12.64L.27,9.48A.37.37,0,0,0,.16,10l1.23,1.92a.39.39,0,0,0,.53.11l1.42-.69a5.26,5.26,0,0,0,1.59.88l.22,1.59a.38.38,0,0,0,.38.37H7.81a.38.38,0,0,0,.38-.37l.18-1.55a5.37,5.37,0,0,0,1.84-1l1.43.65a.38.38,0,0,0,.52-.12l1.18-1.95a.54.54,0,0,0,.05-.11V9.53a.4.4,0,0,0-.18-.24L12,8.32a5.43,5.43,0,0,0,.09-1.85,5.55,5.55,0,0,0-.13-.71l1.21-1a.38.38,0,0,0,.11-.52L12,2.32a.38.38,0,0,0-.52-.12L10,2.84A5.5,5.5,0,0,0,8.37,2L8.19.43A.38.38,0,0,0,7.81.05Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -4.98,
    y: -4.95,
    width: 23.38,
    height: 24.14
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.3796ee86a64bb073578aa85e897f8ecf.svg";
export { ForwardRef as ReactComponent };